export const FEATURE_PERMISSIONS = {
  ManageNoteTemplates: ['Templates', 'Create, edit, archive, and delete shared note templates'],
  ManageLetterTemplates: ['Templates', 'Create, edit, archive, and delete shared letter templates'],
  ManageBirthPlanTemplates: ['Templates', 'Manage practice birth plan templates'],
  ManageChecklistTemplates: ['Templates', 'Manage practice checklist templates'],
  LockSharedTemplates: ['Templates', 'Lock/unlock shared templates; editing locked templates also requires template management'],
  ViewInvoices: ['Billing', 'View invoices and payment records'],
  ManageInvoices: ['Billing', 'Create, edit, send, void, and delete invoices and saved charges'],
  ManagePayments: ['Billing', 'Manage payments, refunds, and payment plans'],
  ManageBillingSettings: ['Billing', 'Manage practice payment settings'],
  ViewRevenueCycle: ['RevenueCycle', 'View billing tickets and their documentation packets'],
  CompleteBillingCheckout: ['RevenueCycle', 'Complete checkout for signed clinical documentation'],
  ReviewBilling: ['RevenueCycle', 'Review coding, manage billing tickets, and record handoff'],
  ManageFeeSchedules: ['RevenueCycle', 'Create and update practice fee schedules'],
  ManageBillingCoverage: ['RevenueCycle', 'Manage coverage and billing verification'],
  ViewReports: ['Reports', 'View, run, and export reports'],
  ManageReports: ['Reports', 'Create and manage your saved reports'],
  ManageSharedReports: ['Reports', 'Manage other team members’ saved reports'],
  ViewFaxes: ['Fax', 'View and download organization faxes'],
  SendFaxes: ['Fax', 'Send faxes'],
  ManageFaxInbox: ['Fax', 'Label, link, archive, and delete faxes'],
  ManageFaxContacts: ['Fax', 'Manage the fax contact directory'],
  ManageFaxLines: ['Fax', 'Configure organization fax lines'],
};
export const PERMISSION_PREREQUISITES = {
  CompleteBillingCheckout: 'ViewRevenueCycle', ReviewBilling: 'ViewRevenueCycle',
  ManageFeeSchedules: 'ViewRevenueCycle', ManageBillingCoverage: 'ViewRevenueCycle',
  ManageInvoices: 'ViewInvoices', ManagePayments: 'ViewInvoices', ManageBillingSettings: 'ViewInvoices',
  ManageReports: 'ViewReports', ManageSharedReports: 'ManageReports', SendFaxes: 'ViewFaxes', ManageFaxInbox: 'ViewFaxes',
};
export const BILLING_PERMISSION_CEILING = new Set(['ViewRevenueCycle', 'ReviewBilling', 'ManageFeeSchedules', 'ManageBillingCoverage']);
export function togglePermission(current, name) {
  const next = new Set(current);
  if (next.has(name)) {
    next.delete(name);
    let removed;
    do {
      removed = false;
      for (const [dependent, prerequisite] of Object.entries(PERMISSION_PREREQUISITES)) {
        if (next.has(dependent) && !next.has(prerequisite)) { next.delete(dependent); removed = true; }
      }
    } while (removed);
  } else {
    for (let permission = name; permission; permission = PERMISSION_PREREQUISITES[permission]) next.add(permission);
  }
  return [...next];
}
